import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_0083f5 = setTheme(({ theme }) => `background-color: ${theme.colors.color_0083f5}`);
